<script setup lang="ts">
import { useMask } from 'core/services/mask'

const props = defineProps<{
  calcType: 'default' | 'extended' | 'tile' | 'ab' | 'icons'
  title?: string
  placeholder: string
  button: StoryBlokButton[]
  secondaryButton?: StoryBlokButton[]
  text?: StoryBlokRichText
  image?: StoryBlokImage
  textTooltip?: StoryBlokTooltip[]
  imageTooltip?: StoryBlokTooltip[]
  hideInput?: boolean
  checkbox?: FieldContent[]
  calcParameters?: KeyValuePair[]
  icons?: {
    icon: StoryBlokIcon
  }[]
}>()

const { public: { countryCode } } = useRuntimeConfig()
const { spz } = useMask()

async function redirectToCalc(value: string, type?: string) {
  const domain = ref('')
  const parameter = props.calcParameters?.find(param => param.key === type)?.value || '?findSPZ'

  if (import.meta.client)
    domain.value = window.location.origin

  const isSameDomain = props.button[0].link.url.startsWith('/')
  const url = isSameDomain ? `${domain.value}${props.button[0].link.url}${parameter}=${value}` : `${props.button[0].link.url}${parameter}=${value}`

  navigateTo(`${url}`, { redirectCode: 302, external: true })
}
</script>

<template>
  <div class="flex justify-center h-full">
    <div v-if="calcType === 'default'" class="w-full max-w-[450px]">
      <ComponentSPZCalculatorViewDefault
        v-bind="props"
        :mask="spz"
        :country-code="countryCode"
        @click="redirectToCalc"
      />
    </div>
    <div v-else-if="calcType === 'extended'" class="w-full">
      <ComponentSPZCalculatorViewExtended
        v-bind="props"
        :mask="spz"
        :country-code="countryCode"
        @click="redirectToCalc"
      />
    </div>
    <div v-else-if="calcType === 'tile'" class="w-full">
      <ComponentSPZCalculatorViewTile
        v-bind="props"
        :mask="spz"
        :country-code="countryCode"
        class="h-full"
        @click="redirectToCalc"
      />
    </div>
    <div v-else-if="calcType === 'ab'" class="w-full">
      <ComponentSPZCalculatorViewAB
        v-bind="props"
        :country-code="countryCode"
        @click="redirectToCalc"
      />
    </div>
    <div v-else-if="calcType === 'icons'" class="w-full">
      <ComponentSPZCalculatorViewIcons
        v-bind="props"
        :mask="spz"
        :country-code="countryCode"
        @click="redirectToCalc"
      />
    </div>
  </div>
</template>
